import { SxProps, Theme } from '@mui/material';
import React from 'react';

import { ServiceTypeEnum } from '_lib/api/apiTypes.shim';

import { MenuItem } from '_lib/components/MenuItem/MenuItem';
import { TextField } from '_lib/components/TextField/TextField';
import { Typography } from '_lib/components/Typography/Typography';
import { FieldIssueProps } from '_lib/utils/validationErrorUtils';

export interface ServiceTypeSelectProps extends FieldIssueProps {
  onSetServiceType: (serviceType: ServiceTypeEnum) => void;
  serviceType: ServiceTypeEnum | null;
  serviceTypes: Readonly<ServiceTypeEnum[]>;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

export const ServiceTypeSelect = (props: ServiceTypeSelectProps) => {
  const { onSetServiceType, serviceType, serviceTypes, issuePath, issues, disabled, sx } = props;

  return (
    <TextField
      fullWidth
      label='Service Type'
      required
      disabled={disabled || serviceTypes.length === 1}
      value={serviceType || ''}
      defaultValue={''}
      select
      sx={sx}
      error={{
        issues,
        issuePath
      }}
      onChange={(e) => {
        if (e.target.value) {
          const value = parseInt(e.target.value);
          if (!isNaN(value)) onSetServiceType(value);
        }
      }}>
      {serviceTypes.map((serviceType: ServiceTypeEnum) => (
        <MenuItem key={serviceType} value={serviceType}>
          <Typography text={ServiceTypeEnum[serviceType]} />
        </MenuItem>
      ))}
    </TextField>
  );
};
